<template>
    <div class="card-list">
        <div v-if="type === 6" class="draft-type">
            <span v-for="type in draftTypeList" :key="type.label" :class="type.active ? 'active' : ''" @click="handleChangeDraftType(type)">{{type.label}}</span>
        </div>
        <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
            <div class="card-list-content" >
                <div class="card-list__total">{{ totalText }}</div>
                <div class="card-list__content">
                    <div
                        class="card-list__content-item"
                        :class="type === 8 ? 'card-list__content-material' : ''"
                        v-for="(item, index) in list"
                        :key="index"
                        @mouseenter="item.actionBar = true"
                        @mouseleave="item.actionBar = false"
                    >
                        <Card :data="item" v-if="type !== 8" @openDetail="openDetail" />
                        <div v-else class="material-content">
                            <div class="material-content-item">
                                <img :src="item.imageUrl[0]" v-if="item.imageUrl && item.imageUrl.length" alt="" @click="handleImage(item)" @contextmenu.prevent="forbidden">
                                <div class="material-item-title">{{item.content}}</div>
                            </div>
                        </div>
                        <!-- 审核状态 -->
                        <div class="card-status card-status--warning" v-if="isOwner && item.isOpen === 0">未审核</div>
                        <!-- <div class="card-status card-status--success" v-if="item.isOpen === 1">已通过</div> -->
                        <div class="card-status card-status--error" v-if="isOwner &&item.isOpen === 2">不通过</div>
                        <!-- 操作栏 -->
                        <div class="card-actionBar" v-if="isOwner && item.actionBar">
                            <div class="card-actionBar__item" v-if="(item.isOpen === 1 || item.isOpen === 2) && actionBarType === 0 && type !== 8" @click.stop="handleEdit(item.id)">
                                <svg-icon icon-class="edit" class-name="icon-edit"></svg-icon>
                            </div>
                            <div class="card-actionBar__item" v-if="actionBarType === 0" @click.stop="handleDelete(item.id)">
                                <svg-icon icon-class="delete" class-name="icon-delete"></svg-icon>
                            </div>
                            <div class="card-actionBar__item" v-if="actionBarType === 1" @click.stop="handleCollect(item)">
                                <svg-icon
                                    :icon-class="item.isCollect ? 'uncollectbar' : 'collectbar'"
                                    :class-name="item.isCollect ? 'icon-uncollectbar' : 'icon-collectbar'"
                                ></svg-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-list__pagination">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="true"
                        :page-size="pageSize"
                        :current-page="pageNum"
                        :total="total"
                        @current-change="handlePageChange">
                    </el-pagination>
                </div>
            </div>

        <PreviewWork v-if="workDialogVisible && workId" :id="workId" :visible.sync="workDialogVisible"></PreviewWork>
        <PreviewArticle v-if="articleDialogVisible && articleId" :id="articleId" :visible.sync="articleDialogVisible"></PreviewArticle>
        <img-dialog-show :img-dialog-show.sync="imgDialogShow" :img-url-arr="pictureList" :img-index="index"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ImgDialogShow from '@/components/ImgDialogShow';
import Card from '@/views/components/Card';
import EmptyPage from '@/components/EmptyPage';
import PreviewWork from './PreviewWork';
import PreviewArticle from './PreviewArticle';
import { openWindow } from '@/utils/utils';
import { getUserWorkList, getUserCollectWorkList, collectZuoPin, cancleCollectZuoPin, deleteZuoPin, getWorkTabs } from '@/api/works';
import { getUserArticleList, getUserCollectArticleList, collectArticle, cancleCollectArticle, deleteArticle } from '@/api/experience';
import { getProject, deleteProject } from '@/api/projectCase';
import { getUploadMaterial, deleteMaterial } from '@/api/material';

export default {
    name: 'CardList',
    components: {
        Card,
        EmptyPage,
        PreviewWork,
        PreviewArticle,
        ImgDialogShow
    },
    inject: ['backTop'],
    props: {
        type: {
            type: [Number, String],
            default: 0
        },
        user: {
            type: Object,
            default: () => {}
        },
    },
    data: () => ({
        index:0,
        loading: true,
        imgDialogShow:false,
        list: [],
        pictureList:[],
        pageSize: 20,
        pageNum: 1,
        total: 0,
        categoryList: [
            { label: '原创', value: 3 },
            { label: '转载', value: 1 },
            { label: '自译', value: 2 }
        ],
        draftTypeList: [
            { label: '作品', value: 0, active: true },
            { label: '经验', value: 1, active: false },
            { label: '企业案例', value: 5, active: false }
        ],
        workId: null,
        workDialogVisible: false,
        articleId: null,
        articleDialogVisible: false
    }),
    computed: {
        ...mapState('user', ['userInfo']),
        isOwner() {
            let isOwner = false;
            if (this.userInfo && this.user && this.userInfo.id === this.user.id) {
                isOwner = true;
            }
            return this.type === 8 ? true : isOwner;
        },
        totalText() {
            let text = '';
            if (this.type === 0) {
                text = `共上传${this.total}组作品`;
            } else if (this.type === 1) {
                text = `共上传${this.total}组经验`;
            } else if (this.type === 2) {
                text = `共收藏${this.total}组作品`;
            } else if (this.type === 3) {
                text = `共收藏${this.total}组经验`;
            } else if (this.type === 8) {
                text = `共${this.total}个素材`;
            }
            return text;
        },
        actionBarType() {
            let type = null;
            if (this.type === 0 || this.type === 1 || this.type === 5 || this.type === 6 || this.type === 8) {
                type = 0;
            } else if (this.type === 2 || this.type === 3) {
                type = 1;
            }
            return type;
        }
    },
    watch: {
        type() {
            this.loading = true;
            this.list = [];
            this.initPageParams();
            this.getData();
        },
        user: {
            deep: true,
            handler() {
                this.initPageParams();
                this.getData();
            }
        }
    },
    created() {
        this.getLabelList()
    },
    mounted() {
        this.initPageParams();
        this.getData();
    },
    methods: {
        handleImage(item) {
            this.pictureList = (item.imageUrl || []).map(img => ({address:img}))
            this.imgDialogShow = true;
            this.index = 0;
        },
        getLabelList() {
            // 获取作品标签
            getWorkTabs({
                type: 3
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.categoryList = [
                    ...options
                ];
            });
        },
        /**
         * 点击修改草稿显示类型
         * @params type 草稿显示类型
         */
        handleChangeDraftType(type) {
            this.draftTypeList.forEach(item => {
                item.active = type.value === item.value;
            });
            this.getData();
        },
        initPageParams() {
            this.pageNum = 1;
            this.pageSize = 20;
        },
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.backTop();
            this.getData();
        },
        async getData() {
            try {
                let res = null;
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    status: this.type === 6 ? 2 : 1
                }
                if (this.type === 0 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 0)) {
                    params.publisher = this.user.id;
                    res = await getUserWorkList(params);
                } else if (this.type === 1 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 1)) {
                    params.publisher = this.user.id;
                    res = await getUserArticleList(params);
                } else if (this.type === 2) {
                    params.userId = this.user.id;
                    res = await getUserCollectWorkList(params);
                } else if (this.type === 3) {
                    params.userId = this.user.id;
                    res = await getUserCollectArticleList(params);
                } else if (this.type === 5 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 5)) {
                    params.userId = this.user.id;
                    res = await getProject(params);
                } else if (this.type === 8) {
                    params.userId = this.user.id;
                    res = await getUploadMaterial();
                }
                const { code, data } = res;
                if (res && code === 0) {
                    if (this.type === 5 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 5)) {
                        this.list = data.map(item => {
                            return {
                                id: item.id,
                                type: 5,
                                title: item.title,
                                image: item.cover,
                                isOpen: item.audit,
                                actionBar: false,
                                isCollect: true
                            };
                        });
                    } else if(this.type === 8) {
                        this.list = (data || []).map(item => {
                            return {
                                ...item,
                                type: 8,
                                isOpen: item.status,
                                actionBar: true,
                            };
                        });
                        this.total = data.length;
                    } else {
                        this.list = data.result.map(item => {
                            let category = null;
                            this.categoryList.forEach(a => {
                                if (a.value === item.labelId) {
                                    category = a.label;
                                    return;
                                }
                            });
                            return {
                                id: item.id,
                                type: item.type,
                                title: item.title,
                                follow: item.viewCount, // 浏览量
                                collect: item.collectionCount, // 点赞量
                                like: item.zanCount, // 收藏量
                                category,
                                image: item.logo,
                                name: item.user && item.user.name,
                                avatar: item.user && item.user.imageAddress,
                                recommend: item.recommend,
                                isOpen: item.isOpen,
                                actionBar: false,
                                isCollect: true
                            };
                        });
                    }
                    this.total = data.total || data.length;
                }
            } catch (e) {
                throw e;
            } finally {
                this.loading = false;
            }
        },
        handleEdit(id) {
            const menuActiveType = (this.draftTypeList.find(item => item.active) || {}).value
            let url = '';
            // // 用户作品文章跳转
            // if (menuActiveType === 0) {
            //     url = `/#/upload/works?id=${id}`
            // } else if (menuActiveType === 1) {
            //     url = `/#/upload/experience?id=${id}`
            // } else if (menuActiveType === 5) {
            //     url = `/#/upload/case?id=${id}`
            // }

            // 用户作品文章跳转
                if (this.type === 0 || (this.type === 6 && menuActiveType === 0)) {
                    // this.workId = item.id;
                    // this.workDialogVisible = true;
                    
                    url = `/#/upload/works?id=${id}`
                    // this.$router.push({
                    //     name: 'Upload',
                    //     query: {id}
                    // });
                } else if (this.type === 1 || (this.type === 6 && menuActiveType === 1)) {
                    // this.articleId = item.id;
                    // this.articleDialogVisible = true;
                    url = `/#/upload/experience?id=${id}`
                    // this.$router.push({
                    //     name: 'UploadExperience',
                    //     query: {id}
                    // });
                } else if (this.type === 5 || (this.type === 6 && menuActiveType === 5)) {
                    // this.$router.push({
                    //     name: 'UploadCase',
                    //     query: {id}
                    // });
                    url = `/#/upload/case?id=${id}`
                }
                if (url) {
                    openWindow(url);
                }
        },
        handleDelete(id) {
            const menuActiveType = (this.draftTypeList.find(item => item.active) || {}).value
            const typeMap = {
                0: ['作品', deleteZuoPin],
                1: ['经验', deleteArticle],
                5: ['企业案例', deleteProject],
                8: ['审核素材', deleteMaterial]
            };
            let itemIndex
            let param
            if (this.type === 8) {
                itemIndex = 8;
                param = {
                    id
                }
            } else {
                itemIndex = (this.type === 0 || (this.type === 6 && menuActiveType === 0)) ? 0 : (this.type === 1 || (this.type === 6 && menuActiveType === 1)) ? 1 : 2;
                param = (this.type === 0 || (this.type === 6 && menuActiveType === 0)) ? { zId: id, userId: this.user.id } : (this.type === 1 || (this.type === 6 && menuActiveType === 1)) ? { articleId: id, userId: this.user.id } : id;
            }
            
            this.$confirm(`删除${typeMap[itemIndex][0]}将不可恢复，确定删除？`).then(() => {
                typeMap[itemIndex][1](param).then(({ code }) => {
                    if (code === 0) {
                        this.$message.success('删除成功');
                        this.loading = true;
                        this.list = [];
                        this.initPageParams();
                        this.getData();
                    }
                });
            })
        },
        handleCollect(item) {
            if (this.type === 2) {
                if (!item.isCollect) {
                    collectZuoPin({ zId: item.id, userId: this.user.id }).then(({ code }) => {
                        if (code === 0) {
                            this.total++;
                            this.$message.success('收藏成功');
                            this.$set(item, 'isCollect', true);
                        }
                    });
                } else {
                    cancleCollectZuoPin({ zId: item.id, userId: this.user.id }).then(({ code }) => {
                        if (code === 0) {
                            this.total--;
                            this.$message.success('已取消收藏');
                            this.$set(item, 'isCollect', false);
                        }
                    });
                }
            } else if (this.type === 3) {
                if (!item.isCollect) {
                    collectArticle({ articleId: item.id, userId: this.user.id }).then(({ code }) => {
                        if (code === 0) {
                            this.total++;
                            this.$message.success('收藏成功');
                            this.$set(item, 'isCollect', true);
                        }
                    });
                } else {
                    cancleCollectArticle({ articleId: item.id, userId: this.user.id }).then(({ code }) => {
                        if (code === 0) {
                            this.total--;
                            this.$message.success('已取消收藏');
                            this.$set(item, 'isCollect', false);
                        }
                    });
                }
            }
        },
        // 打开详情
        openDetail(item) {
            if (this.actionBarType === 1 || (this.actionBarType === 0 && item.isOpen === 1)) {
                // 收藏作品文章跳转
                let url = '';
                if (this.type === 0 || this.type === 2) {
                    url = '/#/works/detail/';
                } else if (this.type === 1 || this.type === 3) {
                    url = '/#/experience/detail/';
                }
                if (url) {
                    openWindow(url + item.id);
                }
            } else if (this.actionBarType === 0) {
                // 用户作品文章跳转
                if (this.type === 0 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 0)) {
                    // this.workId = item.id;
                    // this.workDialogVisible = true;
                    this.$router.push({
                        name: 'Upload',
                        query: {id: item.id}
                    });
                } else if (this.type === 1 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 1)) {
                    // this.articleId = item.id;
                    // this.articleDialogVisible = true;
                    this.$router.push({
                        name: 'UploadExperience',
                        query: {id: item.id}
                    });
                } else if (this.type === 5 || (this.type === 6 && this.draftTypeList.find(item => item.active).value === 5)) {
                    this.$router.push({
                        name: 'UploadCase',
                        query: {id: item.id}
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.draft-type {
    height: 40px;
    line-height: 40px;
    &>span {
        margin-right: 20px;
        padding: 5px 15px;
        border-radius: 25px;
        border: 1px solid #2F54EB;
        color: #2F54EB;
        cursor: pointer;
        &.active {
            background-color: #2F54EB;
            border: 1px solid #2F54EB;
            color: #fff;
            &:hover {
                border: 1px solid #2F54EB;
                color: #fff;
            }
        }
        &:hover {
            border: 1px solid #A8ADC1;
            color: #A8ADC1;
        }
    }
}
.card-list {
    margin-top: 20px;
    overflow: hidden;

    &-content {
        min-height: 588px;
    }

    &__total {
        height: 20px;
        line-height: 20px;
        @include font(rgba(113, 119, 152, 1), 14px, 400);
    }

    &__content {
        margin-top: 10px;
        width: 1600px;
        overflow: hidden;

        &-item {
            position: relative;
            display: inline-block;
            width: 300px;
            height: 250px;
            margin-right: 25px;
            margin-top: 0;

            &:nth-child(5n + 5) {
                margin-right: 0;
            }

            &:nth-child(n + 6) {
                margin-top: 20px;
            }

            .card-status {
                position: absolute;
                z-index: 1;
                left: 0;
                top: 15px;
                width: 60px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 0px 4px 4px 0px;
                @include font(rgba(245, 246, 249, 1), 14px, 400);

                &--success {
                    background-color: rgba(82, 196, 26, 1);
                }

                &--warning {
                    background-color: rgba(255, 85, 0, 1);
                }

                &--error {
                    background-color: rgba(255, 28, 28, 1);
                }
            }

            .card-actionBar {
                position: absolute;
                z-index: 1;
                top: 15px;
                right: 10px;
                width: 24px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                &__item {
                    width: 24px;
                    height: 24px;
                    background-color: #eee;
                    color: #2F54EB;
                    border-radius: 3px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    &:hover {
                        background-color: #fff;
                    }

                    &:not(:first-child) {
                        margin-top: 10px;
                    }

                    .icon-uncollectbar,
                    .icon-delete {
                        color: #F56C6C;
                    }
                }
            }
        }
        &-material {
            width: 385px;
            height: 264px;
            margin-top: 20px;
        }
    }

    &__pagination {
        margin: 45px 0;
        text-align: center;
    }
    .material-content {
        .material-content-item {
            width: 385px;
            height: 264px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            margin-right: 20px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding-bottom: 12px;
            img {
                width: 100%;
                height: 200px;
                cursor: pointer;
            }
            .material-item-title {
                flex: 1;
                padding: 12px 12px 0 12px;
                font-size: 14px;
                font-weight: 400;
                color: #8C8C8C;
                line-height: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                white-space: normal;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .card-list {
        margin-top: 15px;

        &-content {
            min-height: 450px;
        }

        &__total {
            height: 15px;
            line-height: 15px;
        }

        &__content {
            width: 1200px;

            &-item {
                width: 225px;
                margin-right: 15px;

                &:nth-child(n + 6) {
                    margin-top: 15px;
                }

                .card-status {
                    top: 10px;
                }

                .card-actionBar {
                    top: 10px;
                }
            }
        }

        &__pagination {
            margin-top: 30px;
            text-align: center;
        }
    }
}
</style>
